<div class="banner">
  <h1>Refer a Friend</h1>
</div>
<fgb-balance-bar></fgb-balance-bar>
<fgb-account-nav></fgb-account-nav>

<div class="container">
  <fgb-refer-a-friend></fgb-refer-a-friend>
</div>
